<!--
Find a space container for the study space and room booking screens
@author cm359n
-->

<template>
  <div id="contain" class="container">
    <Nav :name="isStaff ? 'Meeting Spaces' : 'Study Spaces'" :showNotif="true" :step="true" />
      <div>
          <div class="start-message">
              <div class="start-header">
                  Discover spaces for your {{ isStaff ? 'meeting' : 'study' }} needs
              </div>
              <div class="start-text">
                  A range of {{ isStaff ? 'meeting' : 'study' }} spaces are available, including bookable rooms{{ isStaff ? '.' : ' for group study.' }}
              </div>
          </div>
              <div class="aaContainer">
                <ExpandSection title='Need accessibility assistance?' >
                  <div class="accessAbleLogo">
                    <img src="@/assets/AccessAble-logo.png" alt="AccessAble logo" />
                  </div>
                  <div class="accessAbleText">The University strives to make the campus accessible to all users.
                    AccessAble is a guide for users with accessibility needs.
                    Tap below to search for rooms and venues that can meet your access needs.
                  </div>
                      <div class='aaSeeMoreBtn'>
                        <input type="button" value="See More" @click="goAALink()" class="searchButton"/>
                      </div>
                </ExpandSection>
        </div>
        <ul class="findaspace-nav-tabs nav nav-tabs eventNavUl">
          <li class="eventNav" style="width:50% !important" :class="dateActiveClass(0)">
            <button @click="selectTab(0)">Drop In</button>
          </li>
          <li class="eventNav" style="width:50% !important" :class="dateActiveClass(1)">
            <button @click="selectTab(1)">Bookable</button>
          </li>
        </ul>
      </div>
      <!-- study spaces -->
    <FeatureSwitch v-if="seltab == 0" name="findaspace_dropin">
      <template v-slot:alternate>
        <!-- what to show if the user is excluded from the feature ... -->
        <OutOfService text="Sorry, this feature is currently under maintainance" />
      </template>
      <div class="tabContent" v-if="seltab == 0">
        <Occupancy :qr="qrCode"/>
      </div>
    </FeatureSwitch>

      <!-- room booking -->
      <div class="tabContent" v-if="seltab == 1 && hasRoomBookingAccess">
        <BookingSearchDetails :givenLocation="roomId" :source="src" />
      </div>
      <div class="tabContent" v-if="seltab == 1 && !hasRoomBookingAccess" >
        <div class="noBookingAccess">
            <Announcement category="21" />
        </div>
      </div>
    <div id="pusher"></div>
    <Footer active="findaspace"/>
  </div>
</template>

<script setup>
import {ref, onMounted} from 'vue'
import * as lst from '@/components/localStorage.js'
import {useRoute, useRouter} from 'vue-router'

//Components
import Footer from '@/components/FooterMenu.vue'
import BookingSearchDetails from '@/views/booking/SearchDetails.vue'
import Occupancy from '@/components/spaces/Occupancy.vue'
import Announcement from '@/components/Announcement.vue'
import ExpandSection from '@/components/ExpandSection.vue'
import FeatureSwitch from '@/components/FeatureSwitch.vue'
import OutOfService from '../components/OutOfService.vue'

//Data
const route = useRoute()
const router = useRouter()
const hasRoomBookingAccess = ref(lst.getValue('hasRoomBookingAccess') === true)
const seltab = ref(0)
const roomId = ref(undefined)
const src = ref(undefined)
const qrCode = ref(null)
const isStaff = ref(lst.getValue('userRoles').includes('UOG'))

onMounted(
  () => {
    if (route.query.src && seltab.value == 0) {
      qrCode.value = route.query.src
      // note "src" gets lost when the tab gets switched...
      selectTab(1)
    }
    if (route.query.roomId) {
      roomId.value = route.query.roomId
      src.value = route.query.src
      console.log('OK, we need to pass room id ' + roomId.value + ' to the booking screen')
    }
    let requestedTab = route.params.tab
    if (typeof requestedTab !== 'undefined' && requestedTab !== '') {
      const reqtab = parseInt(route.params.tab)
      seltab.value = reqtab
    }
  }
)

function dateActiveClass (tabNumber) {
  return { dateActive: seltab.value == tabNumber, dateInactive: seltab.value != tabNumber }
}

function goAALink () {
  window.open('https://www.accessable.co.uk/searches?query=&location_query=University+of+glasgow&commit=Search')
}

function selectTab (t) {
    let newtab = parseInt(t)
    console.log('currently selected tab: ' + seltab.value + ', new tab requested: ' + newtab)
    if (seltab.value != newtab) {
      seltab.value = t + 0
      // preserve the roomId if we were given one
      const roomId = route.query.roomId
      // const src = this.$route.query.src
      if (typeof roomId !== 'undefined') {
        // console.log('**** we were given a room id: ' + roomId)
        router.push({
          path: 'findaspace/' + t,
          query: {
            roomId: roomId
            // src: src /* setting this seems to cause whitescreen on hitting back so let's not do that */
          }
        })
      } else {
        router.push('/findaspace/' + t)
      }
      console.log(seltab.value)
    }
  }

</script>

<style lang="scss" scoped>

.start-message {
  margin-left:24px;
  margin-right:24px;
}

.noBookingAccess {
  margin:20px;
}
.tabContent {
  margin-top:8px;
}
.dateActive {
  background: inherit;
  border-bottom: 2px solid var(--uog-dark-blue);
  color: var(--uog-dark-blue);
  font-weight:900;
}
.dateActive a {
  color: var(--uog-dark-blue);
}
.dateInactive a {
  color: var(--uog-dark-blue);
}
.eventNav {
  font-weight:900;
  width:50%;
}
.eventNavUl {
  padding-left:0% !important;
  padding-right:0% !important;
  border-bottom:0px !important;
  overflow: hidden;
}
.eventNav {
  display: block;
  width:50%;
  text-align:center;
  line-height:50px;
  height:50px;
}

.findaspace-nav-tabs button {
  background: transparent;
  border: none;
  color: var(--uog-dark-blue);
}

.findaspace-nav-tabs .dateActive button {
  color: var(--uog-dark-blue);
}

.start-header {
    margin-top: 25px;
    font-style: normal;
    font-weight: bold;
    font-size: 18px;
    line-height: 23px;
    color: var(--uog-dark-blue);
}
.start-text {
    margin-top: 20px;
    margin-bottom:20px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 21px;
}
.findaspace-nav-tabs {
  background-color: var(--uog-blue-10) !important;
}
.accessAbleLogo {
  margin-top: 21px;
  margin-bottom: 14px;
}
.accessAbleLogo img {
  width: 160px;
  height: 32px;
}
.accessAbleText {
  font-size: 18px;
  font-weight: 400;
  text-align: left;
}
.aaContainer {
  width: 100%;
  text-align: center;
  margin-bottom: 16px;
}
.aaSeeMoreBtn input {
    font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 21px;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
  height: 55px;
  width: 100%;
  margin-top: 34px;
  margin-bottom: 38px;

  background: var(--uog-dark-blue);
  border-radius: 12px;
  border-color: var(--uog-dark-blue);
  border-style: solid;

}
</style>


